import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { ArrowRight } from 'lucide-react'
import { useAuthStore } from '@/lib/store/auth'
import { Button } from '@/components/ui/button'
import { LogoMark } from '@/components/ui/logo'
import { GraphBackdrop } from './graph-backdrop'
import { HeroDemo } from './hero-demo'

export function Hero() {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated)
  const openLoginDialog = useAuthStore((s) => s.openLoginDialog)
  const handleCta = () => {
    if (isAuthenticated) navigate('/dashboard')
    else openLoginDialog()
  }

  return (
    <section className="relative isolate overflow-hidden">
      <div className="absolute inset-0 landing-grid-bg" aria-hidden />
      <GraphBackdrop />

      <div
        className="landing-ambient"
        style={{ top: '-10%', left: '12%', width: '460px', height: '460px' }}
        aria-hidden
      />
      <div
        className="landing-ambient"
        style={{ top: '8%', right: '8%', width: '400px', height: '400px', animationDelay: '6s' }}
        aria-hidden
      />
      <div
        className="landing-ambient"
        style={{ bottom: '-18%', left: '42%', width: '480px', height: '480px', animationDelay: '10s', opacity: 0.4 }}
        aria-hidden
      />

      <div className="relative mx-auto max-w-3xl px-6 pt-24 text-center sm:pt-28">
        <div className="landing-fade-up flex justify-center" style={{ animationDelay: '100ms' }}>
          <div className="landing-float">
            <LogoMark size={72} />
          </div>
        </div>

        <h1
          className="landing-fade-up mt-7 text-5xl font-bold tracking-tight text-foreground sm:text-6xl md:text-7xl"
          style={{ animationDelay: '200ms' }}
        >
          {t('landing.hero.headline')}
        </h1>

        <p
          className="landing-fade-up mx-auto mt-6 max-w-2xl text-base text-muted-foreground sm:text-lg md:text-xl"
          style={{ animationDelay: '350ms' }}
        >
          {t('landing.hero.subheadline')}
        </p>

        <div
          className="landing-fade-up mt-9 flex flex-wrap items-center justify-center gap-3"
          style={{ animationDelay: '500ms' }}
        >
          <Button size="lg" onClick={handleCta} className="group">
            <span className="flex items-center gap-2">
              {t('landing.hero.ctaPrimary')}
              <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
            </span>
          </Button>
          <Button
            size="lg"
            variant="outline"
            onClick={() => navigate('/pricing')}
            className="glass-card"
          >
            {t('landing.hero.ctaSecondary')}
          </Button>
        </div>
      </div>

      <div
        className="landing-fade-up relative mx-auto max-w-5xl px-6 pb-24 sm:pb-28"
        style={{ animationDelay: '640ms' }}
      >
        <HeroDemo />
      </div>

      <div className="pointer-events-none absolute inset-x-0 bottom-0 h-32 bg-gradient-to-b from-transparent to-background" aria-hidden />
    </section>
  )
}
